import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "../button/Button";
import Header from "../layout/header/Header";
import Wrapper from "../layout/wrapper/Wrapper";
import "./Tray.scss";

interface IProps {}

export default function Tray(props: IProps) {
    return (
        <Wrapper style={{ flexDirection: "column" }}>
            <Header>
                <Button variant="secondary" iconOnly>
                    <FontAwesomeIcon icon={faPlus} />
                </Button>
            </Header>
        </Wrapper>
    );
}
